/* ============================================
   THE VITAMIN PATCH — shopify-config.js
   Storefront API — Public Access (No Token)
   ============================================
   This file connects your HTML to Shopify's
   public Storefront API. No token or app setup
   required. Works immediately.

   SCRIPT LOAD ORDER in every HTML page,
   just before your closing </body> tag,
   BEFORE script.js:

   <script src="shopify-config.js"></script>
   <script src="shopify-cart.js"></script>
   <script src="shopify-products.js"></script>
   <script src="shopify-search.js"></script>
   <script src="script.js"></script>
   ============================================ */

window.TVP = window.TVP || {};

window.TVP.config = {
  storeDomain: 'the-vitamin-patch.myshopify.com',
  apiVersion:  '2025-01',

  get endpoint() {
    return 'https://' + this.storeDomain + '/api/' + this.apiVersion + '/graphql.json';
  },

  /* Public unauthenticated access headers —
     no token needed for reading products */
  get headers() {
    return {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'e4820d01801a3accf35c718fd69cbce8' /* left blank for public access */
    };
  }
};

/* ============================================
   CORE API HELPER
   All Shopify calls go through this function.
   Usage: TVP.api(query, variables).then(data => { ... })
   ============================================ */
window.TVP.api = function(query, variables) {
  return fetch(window.TVP.config.endpoint, {
    method:  'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query: query, variables: variables || {} })
  })
  .then(function(res) {
    if (!res.ok) throw new Error('Shopify API error: ' + res.status);
    return res.json();
  })
  .then(function(json) {
    if (json.errors) {
      console.error('[TVP] GraphQL errors:', json.errors);
      throw new Error(json.errors[0].message);
    }
    return json.data;
  });
};

/* ============================================
   PRICE FORMATTER
   TVP.formatPrice('34.95') → '$34.95'
   ============================================ */
window.TVP.formatPrice = function(amount) {
  return '$' + parseFloat(amount).toFixed(2);
};

console.log('[TVP] Shopify connected — ' + window.TVP.config.storeDomain);
